import FormBuilderConfig from "../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IButtonBuilder from "../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import ISelectBuilder from "../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";

export type Inputs = "mes" | "anio";
export type Buttons = "precalculo" | "simulacion";

const meses = {
  1: "Enero",
  2: "Febrero",
  3: "Marzo",
  4: "Abril",
  5: "Mayo",
  6: "Junio",
  7: "Julio",
  8: "Agosto",
  9: "Septiembre",
  10: "Octubre",
  11: "Noviembre",
  12: "Diciembre"
};

const mesesOpts = [];
for (const key in meses) {
  mesesOpts.push({
    label: meses[key],
    value: key
  });
}

const currentYear = new Date().getFullYear();
const aniosOpts = [
  { label: currentYear - 1, value: currentYear - 1 },
  { label: currentYear, value: currentYear }
];

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "mes",
      label: "Mes",
      bts: { mCol: 3 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione mes",
        data: mesesOpts
      }
    },
    {
      name: "anio",
      label: "Año",
      bts: { mCol: 3 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione año",
        data: aniosOpts
      }
    }
  ],
  buttons: [
    {
      name: "precalculo",
      label: "Precálculo",
      isSubmit: true,
      bts: {
        mCol: 3
      },
      component: IButtonBuilder
    },
    {
      name: "simulacion",
      label: "Simulación de cierre",
      isSubmit: false,
      bts: {
        mCol: 3
      },
      component: IButtonBuilder
    }
  ],
  validations: {
    mes: {
      required: true
    },
    anio: {
      required: true
    }
  },
  rows: [["mes", "anio", "precalculo", "simulacion"]]
};
